import axios from 'axios'
import querystring from 'querystring'

// initial state

const state = {
  config: {},
  breadcrumbs: [],
  system: null
}

// getters
const getters = {
  config: state => state.config,
  breadcrumbs: state => state.breadcrumbs,
  system: state => state.system
}

// actions
const actions = {
  getConfig: function (context) {
    return axios.get('./config.json')
    .then(
      (response) => {
        context.commit('SET_CONFIG', response.data)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getSystem: function (context) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getSystemMembers,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password
      })
    )
    .then(
      (response) => {
        context.commit('SET_SYSTEM', response.data[0])
        console.log(response)
      }
      )
      .catch(
        (error) => {
          context.commit('SET_SYSTEM', 
            {
              id: 1,
              status: '2'
            }
          )
          console.log(error)
      }
    )
  }
}

// mutations
const mutations = {
  SET_CONFIG (state, config) {
    state.config = config
    console.log('SET_CONFIG')
    console.log(state.config)
  },
  SET_SYSTEM (state, data) {
    state.system = data
    console.log('SET_SYSTEM')
    console.log(state.system)
  },
  ADD_BREADCRUMB (state, breadcrumb) {
    state.breadcrumbs.push(breadcrumb)
    console.log('ADD_BREADCRUMB')
    console.log(state.breadcrumbs)
  },
  CUT_BREADCRUMBS (state, level) {
    state.breadcrumbs.splice(level)
    console.log('CUT_BREADCRUMBS')
    console.log(state.breadcrumbs)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
